import React, { useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  Popper,
  TextField,
  Toolbar,
} from "@material-ui/core";
import { SearchOutlined } from "@material-ui/icons";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import Axios from "axios";
import { RootUrl } from "../../redux/types";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
      margin: "0vh 2vw",
    },
  },
  gridContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: 70,
  },
  fieldContainer: {
    flex: 1,
    borderRadius: 50,
  },
  searchIcon: {
    borderTopRightRadius: 50,
    borderBottomRightRadius: 50,
    height: 41,
    width: 41,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 0,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
    "&:active": {
      backgroundColor: theme.palette.primary.main,
    },
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  input: {
    // color: "white",
    borderColor: "red",
  },
  inputRoot: {
    borderTopLeftRadius: 50,
    borderBottomLeftRadius: 50,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRight: "none",

    // backgroundColor: "red",
    // border: "2px solid red",
    "&.input": {
      border: "2px solid red",
    },
    "&.Mui-focused": {
      // border: "2px solid red",
      "&.MuiInput": {
        borderColor: "2px solid red",
      },
    },
  },
  outlined: {
    // borderRightColor: "green",
    // "&:focused": {
    //   borderRightColor: "yellow",
    // },
    // "&:active": {
    //   borderRightColor: "yellow",
    // },
  },
  focused: {
    borderRightColor: "orange",
  },
  popOver: {
    marginTop: theme.spacing(-2),
  },
  container: { borderRadius: 10, maxHeight: "45vh", overflowY: "auto" },

  closeBtnContainer: {
    marginBottom: theme.spacing(1),
  },
}));

const SearchBar = ({ data }) => {
  const classes = useStyles();
  const anchorRef = useRef();
  const lang = useSelector((state) => state.util.language);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [grams, setGrams] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
    setGrams([]);
  };

  const handleChange = (e) => {
    e.preventDefault();
    setSearchQuery(e.target.value);
    if (e.target.value && e.target.value.length >= 2 && !isLoading) {
      handleSearch();
    } else {
      setOpen(false);
    }
  };

  const handleSearch = async (data) => {
    setIsLoading(true);

    await Axios.get(`${RootUrl}/searchgram/${searchQuery}/${lang}`, {
      headers: {
        "Content-Type": "application/json",
      },
    }).then((res) => {
      setOpen(true);
      setGrams(res.data.data);
      setIsLoading(false);
    });
  };

  const handleNavigate = (link) => {
    window.open(link);
  };

  const renderGram = (data, index) => {
    return (
      <>
        <ListItem key={index} button onClick={() => handleNavigate(data?.link)}>
          <ListItemText
            primary={`${data.nameInGj} (${data.gramName})`}
            secondary={`Taluka :${data.taluko} District :${data.district}`}
          />
        </ListItem>
        <Divider />
      </>
    );
  };

  const renderNotData = () => {
    return (
      <>
        <ListItem button onClick={() => handleClose()}>
          <ListItemText primary={"No data found"} />
        </ListItem>
        <Divider />
      </>
    );
  };
  return (
    <div className={classes.root}>
      <div className={classes.gridContainer} ref={anchorRef}>
        <div className={classes.fieldContainer}>
          <TextField
            placeholder={data}
            size="small"
            variant="outlined"
            fullWidth
            className={classes.TextField}
            onChange={(e) => handleChange(e)}
            InputProps={{
              //   className: classes.input,
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.outlined,
                focused: classes.focused,
                input: classes.input,
                // because i used variant="outlined" i can pass any classes here that the OutlinedInput uses
              },
              endAdornment: (
                <InputAdornment position="end">
                  {isLoading && <CircularProgress size={15} />}
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className={classes.iconContainer}>
          <IconButton className={classes.searchIcon} onClick={handleSearch}>
            <SearchOutlined />
          </IconButton>
        </div>
        {open && (
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            onClose={handleClose}
            className={classes.popOver}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <Paper
              style={{ width: anchorRef.current.offsetWidth }}
              className={classes.container}
            >
              {grams.length > 0
                ? grams?.map((gram, index) => {
                    return renderGram(gram, index);
                  })
                : renderNotData()}
              <ListItem className={classes.closeBtnContainer}>
                <Button size="small" variant="outlined" onClick={handleClose}>
                  Close
                </Button>
              </ListItem>
            </Paper>
          </Popper>
        )}
      </div>
    </div>
  );
};
export default SearchBar;
